var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('company.add')))])]),_vm._v(" "),_c('item-create-errors',{attrs:{"entity":'template',"is-loading":_vm.isLoading}}),_vm._v(" "),(!_vm.isLoading)?_c('CompanyForm',{attrs:{"handle-submit":_vm.onSendForm,"handle-update-field":_vm.updateField,"values":_vm.item,"errors":_vm.violations}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb68b4a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Create.vue
// module id = 729
// module chunks = 0